module.exports = __webpack_public_path__ + "img/banner-layer3.838b7053.png";